export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
                name: 'Div',
                attributes: { class: 'd-flex gap-16 wrap margin-top-50' },
                components: [
                    {
                        type: 'itemTestimony2',
                    },
                    {
                        type: 'itemTestimony2',
                    },
                    {
                        type: 'itemTestimony2',
                    },
                    {
                        type: 'itemTestimony2',
                    },
                    {
                        type: 'itemTestimony2',
                    },
                    {
                        type: 'itemTestimony2',
                    },
                ],
                styles: `
                .gap-16{
                    gap: 16px; 
                }
                .wrap{
                    flex-wrap: wrap; 
                }
                .margin-top-50{
                    margin-top: 50px;
                }
      
            `,
            },
        },
        view: {

        },
    };
    return component;
};